import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Navbar } from 'react-bootstrap';

import routeTitle from '../../../constants/route-title';
import vacancyStatuses from '../../../constants/vacancy-statuses';

class NavbarPageTitle extends Component {
  render() {
    const route = routeTitle.find(el => {
      return el.pattern.test(this.props.location.pathname);
    });

    if (route) {
      let routeName = route.name;

      const newRouteName = this.checkConditionalRouteNames(route);

      if (newRouteName) {
        routeName = newRouteName;
      }

      return (
        <Navbar.Text className="header__page-title">
          { routeName }
        </Navbar.Text>
      );
    }

    return null;
  }

  checkConditionalRouteNames(route) {
    if (route.name === 'Vacancy') {
        const vacancy = this.props.vacancyDetails.get('vacancySummary').toJS();

        if (vacancy.status === vacancyStatuses.draft) {
          return 'Vacancy Draft';
        }
      }

      return undefined;
  }
}

NavbarPageTitle = connect(
  state => ({ vacancyDetails: state.vacancyDetails, candidateApplication: state.candidateApplication })
)(NavbarPageTitle);

NavbarPageTitle = withRouter(NavbarPageTitle);

export default NavbarPageTitle;



// WEBPACK FOOTER //
// ./src/components/common/navbar/navbar-page-title.js